import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';

import { PropTypesRepo } from '../functions/_propTypes';

import Div from './Div';

export default class Collapse extends Component {
  constructor() {
    super();

    this.state = {
      defaultHeight: 0,
    };

    this.innerDiv = React.createRef();
    this.onEntering = this.onEntering.bind(this);
    this.onExiting = this.onExiting.bind(this);
  }

  /**
   * Set State for Height on Enter
   */
  onEntering() {
    this.setState({ defaultHeight: this.innerDiv.current.clientHeight });

    // Start Function if recieved a onEntering Props
    const { onEntering } = this.props;
    if (onEntering) onEntering();
  }

  /**
   * Set State for Height on Exit
   */
  onExiting() {
    this.setState({ defaultHeight: this.innerDiv.current.clientHeight });

    // Start Function if recieved a onExiting Props
    const { onExiting } = this.props;
    if (onExiting) onExiting();
  }

  render() {
    const { defaultHeight } = this.state;
    const { p, children, isOpen, ...rest } = this.props;

    /**
     * Duration for the transition
     */
    const duration = 300;

    /**
     * Default Style for Backlayer
     */
    const defaultStyle = {
      transition: `all ${duration}ms ease-in-out`,
      height: 0,
      opacity: 0,
    };

    /**
     * Trasition Styles for Backlayer
     */
    const transitionStyles = {
      entering: { opacity: 0, height: 0 },
      entered: { opacity: 1, height: defaultHeight },
      exiting: { opacity: 1, height: defaultHeight },
      exited: { opacity: 0, height: 0 },
    };

    return (
      <Transition in={isOpen} timeout={duration} onEntering={this.onEntering} onExiting={this.onExiting}>
        {(state) => (
          <Div
            {...rest}
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
            }}
            transition
          >
            <div ref={this.innerDiv}>{children}</div>
          </Div>
        )}
      </Transition>
    );
  }
}

/* eslint-disable react/require-default-props */

Collapse.propTypes = {
  onEntering: PropTypes.func,
  onExiting: PropTypes.func,
  isOpen: PropTypes.bool,
  p: PropTypesRepo.p,
  m: PropTypesRepo.m,
  overflow: PropTypesRepo.overflow,
  children: PropTypes.node,
};

/* eslint-enable react/require-default-props */

Collapse.defaultProps = {
  m: { y: 0 },
  p: { y: 0 },
  overflow: 'hidden',
  onEntering: null,
  onExiting: null,
  isOpen: false,
};
